import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../utils/math/ApplyRounding';
import { CancelOrderButton } from '../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3, fontSizes } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

// possible improvement is to get rid of need for update button, send updatePlugin message on each edit
export const PositionBreakPriceTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const [newPriceInput, setNewPriceInput] = useState(0);
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan?.exitTactics['POSITION_BREAK_PRICE']?.tacticId ?? null;
    const prices = tradePlan.exitTactics['POSITION_BREAK_PRICE']?.prices ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const priceToBreak = softOrder?.value.tacticValue.priceToBreak ?? null;

    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'POSITION_BREAK_PRICE',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.exitTactics['POSITION_BREAK_PRICE']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            {inPosition && softOrder ? (
              <>
                <IndividualPanelHeader />
                <tbody>
                  <tr>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        Price to Break
                      </Body3>
                    </td>
                    <td className={style.inputTd}>
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        $
                      </Body3>
                      <EditableTableField
                        inputType="number"
                        bodySize={3}
                        initialValue={priceToBreak}
                        updateValue={(newValue) =>
                          updateSoftOrder('breakPrice', newValue)
                        }
                        color={colors.lightGrey}
                        backgroundColor="inherit"
                      />
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <thead>
                  <tr>
                    <th>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        Prices
                      </Body3>
                    </th>
                    <th>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        Edit
                      </Body3>
                    </th>
                    <th>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        Add/Remove
                      </Body3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {prices.map((price, index) => {
                    return (
                      <tr key={price}>
                        <td className={style.labelTd}>
                          <Body3 fontWeight={700} color={colors.lightGrey}>
                            {`Price ${index + 1}`}
                          </Body3>
                        </td>
                        <td className={style.inputTd}>
                          <div className={style.inputWrapper}>
                            <Body3
                              fontWeight={700}
                              color={colors.lightGrey}
                              margin="3px 3px 0 0"
                            >
                              $
                            </Body3>
                            <EditableTableField
                              inputType="number"
                              bodySize={3}
                              initialValue={ApplyRounding(Number(price), 2)}
                              updateValue={(newValue) => {
                                const pricesCopy = [...prices];
                                pricesCopy[index] = newValue;
                                updateTactic('prices', pricesCopy);
                              }}
                              color={colors.lightGrey}
                              backgroundColor="inherit"
                            />
                          </div>
                        </td>
                        <td className={style.labelTd}>
                          <CancelOrderButton
                            width={15}
                            clickHandler={() => {
                              const filteredArr = [...prices].filter(
                                (item, i) => i !== index
                              );
                              updateTactic('prices', filteredArr);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        Add Price
                      </Body3>
                    </td>
                    <td className={style.inputTd}>
                      <EditableTableFieldNoOnBlurUpdate
                        inputType="number"
                        fontSize={fontSizes.body3}
                        value={newPriceInput}
                        setValue={(newValue) => setNewPriceInput(newValue)}
                        color={colors.lightGrey}
                        backgroundColor="inherit"
                      />
                    </td>
                    <td>
                      <IncrementButton
                        paddingPercent={10}
                        color={colors.white}
                        backgroundColor={colors.blue}
                        width={10}
                        stroke={1}
                        handleClick={() => {
                          const pricesCopy = [...prices];
                          pricesCopy.push(newPriceInput);
                          updateTactic('prices', pricesCopy);
                        }}
                        buttonWidth="15px"
                      />
                    </td>
                  </tr>
                </tbody>
              </>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);
PositionBreakPriceTacticPanel.tabsRole = 'TabPanel';
